import * as Cookies from "es-cookie"
import { pushTransitionMedia } from "utils/gaMedia"

function setDcmRetUrl() {
  const { location, referrer } = document
  const searchParams = new URLSearchParams(location.search)
  const agent = window.navigator.userAgent.toLowerCase()

  // ホワイトリストはドメイン部分まで管理
  const whitelist = process.env.REACT_APP_WHITELIST.split(",")

  if (
    whitelist.some(domain => !referrer.indexOf(domain)) &&
    searchParams.has("dcmreturl")
  ) {
    const url = searchParams.get("dcmreturl")
    Cookies.set("dcmRetUrl", url, {
      expires: 1 / 24,
    })
    pushTransitionMedia(Cookies.get("dcmRetUrl"))
    return
  } else if (searchParams.has("dcmreturl")) {
    const url = searchParams.get("dcmreturl")
    const urlObj = new URL(url)

    if (whitelist.some(domain => !urlObj.origin.indexOf(domain))) {
      Cookies.set("dcmRetUrl", url, {
        expires: 1 / 24,
      })
      pushTransitionMedia(Cookies.get("dcmRetUrl"))
      return
    }
  }

  if (referrer.length === 0 && agent.indexOf("firefox") === -1) {
    Cookies.remove("dcmRetUrl")
  }
  // 初回のみGA集計を行う
  pushTransitionMedia(Cookies.get("dcmRetUrl"))
}

export default setDcmRetUrl
